/*eslint-disable no-script-url*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as responsiveActions from "../../actions/responsiveActions";

class Dropdown extends Component {
	state = {
		open: false,
	};

	constructor(props) {
		super(props);

		this.setWrapperRef = this.setWrapperRef;
		this.handleClickOutside = this.handleClickOutside;
	}

	componentDidMount() {}

	componentWillUnmount() {
		this.removeListener();
	}

	addListener = () => {
		document.addEventListener("mousedown", this.handleClickOutside);
	};

	removeListener = () => {
		document.removeEventListener("mousedown", this.handleClickOutside);
	};

	setWrapperRef = node => {
		this.wrapperRef = node;
	};

	handleClickOutside = event => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.open) {
			this.toggleMenu();
		}
	};

	toggleMenu = () => {
		const { responsiveActions } = this.props;
		// this.state.open ? this.removeListener() : this.addListener();
		if (this.state.open) {
			this.removeListener();
			responsiveActions.dropdownClose();
		} else {
			this.addListener();
			responsiveActions.dropdownOpen();
		}
		this.setState({ open: !this.state.open });
	};

	render() {
		return (
			<li
				ref={this.setWrapperRef}
				className={`dropdown ${this.props.classNames ? this.props.classNames : ""} ${
					this.state.open ? "open" : ""
				}`}
			>
				<a
					href="javascript:void(0);"
					className="dropdown-toggle"
					onClick={() => {
						this.toggleMenu();
					}}
				>
					{this.props.children}
				</a>

				{this.props.content && this.props.content()}
			</li>
		);
	}
}

Dropdown.propTypes = {
	classNames: PropTypes.string,
	content: PropTypes.func,
	children: PropTypes.any,
};

const mapStateToProps = state => ({
	responsive: state.responsive,
});

const mapDispatchToProps = dispatch => ({
	responsiveActions: bindActionCreators(responsiveActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Dropdown);
